import { render } from "./Menubar.vue?vue&type=template&id=6119fb4a&scoped=true"
import script from "./Menubar.vue?vue&type=script&lang=js"
export * from "./Menubar.vue?vue&type=script&lang=js"

import "./Menubar.vue?vue&type=style&index=0&id=6119fb4a&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-6119fb4a"

export default script